import { render, staticRenderFns } from "./apps-abiz-page.vue?vue&type=template&id=7b2bea30&scoped=true"
import script from "./apps-abiz-page.vue?vue&type=script&lang=js"
export * from "./apps-abiz-page.vue?vue&type=script&lang=js"
import style0 from "./apps-abiz-page.vue?vue&type=style&index=0&id=7b2bea30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2bea30",
  null
  
)

export default component.exports